module.exports = __webpack_public_path__ + "img/medium_left.1c724dab.jpg";